import InputField from 'components/InputField/InputField';

import {
  MarketplaceConfig,
  SettingTypes,
} from "TypesAndInterfaces";
import InputKeyField from 'components/InputKeyField/InputKeyFiels';

interface IProps {
  marketplaceConfig: MarketplaceConfig;
  handleStateUpdate: (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>, number?: boolean, type?: SettingTypes, channelID?: number) => void;
}

const MiraklSettings = ({
  marketplaceConfig,
  handleStateUpdate,
}: IProps) => {

  return <>
    <div className="inputs-wrapper__inputs">
      <p className="main-content__sidebar__title">Mirakl Settings</p>
      <InputField
        label="URL"
        name="url"
        placeholder="Enter Mirakl URL"
        onChange={(e) => handleStateUpdate(e, false, SettingTypes.Mirakl)}
        value={marketplaceConfig.mirakl.url}
      />
      <InputKeyField
        label="API Key"
        name="key"
        showEditButton
        placeholder="Enter Mirakl API Key"
        onChange={(e) => handleStateUpdate(e, false, SettingTypes.Mirakl)}
        ofValue={marketplaceConfig.mirakl.key}
      />
      <InputKeyField
        label="SSO Client ID"
        name="ssoClientId"
        showEditButton
        placeholder="Enter Mirakl SSO Client ID"
        onChange={(e) => handleStateUpdate(e, false, SettingTypes.Mirakl)}
        ofValue={marketplaceConfig.mirakl.ssoClientId}
      />
      <InputKeyField
        label="SSO Client Secret"
        name="ssoClientSecret"
        placeholder="Enter Mirakl SSO Client Secret"
        onChange={(e) => handleStateUpdate(e, false, SettingTypes.Mirakl)}
        ofValue={marketplaceConfig.mirakl.ssoClientSecret}
        showEditButton
      />
    </div>
  </>
};

export default MiraklSettings;